"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeError = void 0;
/**
 * NETWORK ERROR CODES FORMAT: 1****
 * -UPLOAD ERRORS:              1***
 * -DOWNLOAD ERRORS:            2***
 * -CRYPTOGRAPHIC ERRORS:        1**
 *
 */
var UploadErrorCode;
(function (UploadErrorCode) {
    UploadErrorCode[UploadErrorCode["InvalidMnemonic"] = 11100] = "InvalidMnemonic";
})(UploadErrorCode || (UploadErrorCode = {}));
var DownloadErrorCode;
(function (DownloadErrorCode) {
    DownloadErrorCode[DownloadErrorCode["InvalidMnemonic"] = 12100] = "InvalidMnemonic";
})(DownloadErrorCode || (DownloadErrorCode = {}));
var CodeError = /** @class */ (function (_super) {
    __extends(CodeError, _super);
    function CodeError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        return _this;
    }
    return CodeError;
}(Error));
exports.CodeError = CodeError;
exports.default = {
    Upload: UploadErrorCode,
    Download: DownloadErrorCode
};
